// Generated by CoffeeScript 2.7.0
var DEFAULT_WINDOW_OPTIONS, Paginator, popover_comp;

import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js';

import Popover from 'trunks/vue/admin/components/libs/popover.js';

// 参考 https://github.com/kaminari/kaminari#helpers
DEFAULT_WINDOW_OPTIONS = {
  window: 2, // 当前页码左右两侧
  outerWindow: 0, // 第一页和最后一页的大小
  left: 1, // 第一页的大小
  right: 1 // 最后一页的大小
};

popover_comp = Popover;

export default Paginator = Vue.extend({
  components: {
    'dropdown-select': DropdownSelect,
    'popover': popover_comp
  },
  props: {
    resourceUrl: {
      type: String,
      required: true
    },
    additionalParams: {
      type: Object,
      default: function() {
        return {};
      }
    },
    perPage: {
      type: Number,
      default: 24
    },
    perPageRatios: {
      type: Array,
      default: function() {
        return [24, 50, 100];
      }
    },
    viewOptions: {
      type: Object,
      default: function() {
        return {};
      }
    },
    reverseTheme: {
      type: Boolean,
      default: false
    },
    initialPage: {
      type: Number,
      default: 1
    },
    perPageChangeable: {
      type: Boolean,
      default: true
    },
    beforeRequestFunc: {
      type: Function,
      default: _.noop
    },
    afterRequestFunc: {
      type: Function,
      default: _.noop
    }
  },
  data: function() {
    return {
      currentPerPage: this.perPage,
      currentPage: this.initialPage,
      totalPages: 0,
      totalCount: 0,
      windowOptions: (() => {
        var options;
        options = _.extend({}, DEFAULT_WINDOW_OPTIONS, this.viewOptions);
        return {
          window: options.window,
          left: options.left || options.outerWindow,
          right: options.right || options.outerWindow
        };
      })()
    };
  },
  template: `<div class='pagination' :class='{ reverse: reverseTheme }'>
  <div class='perpage-setting'>
    <template v-if='perPageChangeable'>
      <span>每页显示</span>
      <dropdown-select :optionGroups='[{ options: perPageRatios }]'
                       :initValue='currentPerPage'
                       @change='changePerPageFunc'
                       ref='perPageDropdownSelectRef'>
        <template slot='value-template' slot-scope='{ option }'>
          <span>{{ option }}</span>
        </template>
        <template slot='option-template' slot-scope='{ option }'>
          <span>{{ option }}</span>
        </template>
      </dropdown-select>
      <span>条数据</span>
    </template>
  </div>
  <div class='page-indexer'>
    <popover v-if='totalPages > 1'
             position='top center'
             @beforeOpen='resetCurrentPageInput'
             ref='pagePopoverRef'>
      <div slot='trigger' class='btn btn-primary link-btn'>跳转</div>
      <div slot='content' class='redirect-to-container'>
        <div class='redirect-to-input'>
          <span>跳转到</span>
          <input type='text' :value='currentPage' ref='pageInputRef' @keyup.enter='changePageFunc' />
          <span>页</span>
        </div>
        <div class='redirect-to-actions'>
          <div class='btn outlined btn-default btn-small' @click.stop='closePopoverFunc'>取消</div>
          <div class='btn outlined btn-small' @click.stop='changePageFunc'>确定</div>
        </div>
      </div>
    </popover>
    <div v-if='totalPages > 1' class='prev-page' :class='{ disabled: !hasPrevPage }' @click.stop='hasPrevPage && goPrevious()'>
      <i class='slp-chevron-left'></i>
    </div>
    <div class='page-indexes'>
      <template v-for='page in pages'>
        <div v-if="isDisplayPage(page)" class='index-item' :class="indexItemClassObj(page)" @click.stop='go(page)'>{{page}}</div>
        <div v-else class='index-item' :class="indexItemClassObj(page)">&hellip;</div>
      </template>
    </div>
    <div v-if='totalPages > 1' class='next-page' :class='{ disabled: !hasNextPage }' @click.stop='hasNextPage && goNext()'>
      <i class='slp-chevron-right'></i>
    </div>
  </div>
</div>`,
  computed: {
    pages: function() {
      var inside_window_plus_each_sides, last, left_window, right_window;
      left_window = _.range(1, this.windowOptions.left + 1);
      right_window = _.range(this.totalPages - this.windowOptions.right, this.totalPages + 1);
      inside_window_plus_each_sides = _.range(this.currentPage - this.windowOptions.window - 1, this.currentPage + this.windowOptions.window + 1);
      last = 0;
      return _.chain(_.union(left_window, inside_window_plus_each_sides, right_window)).sortBy().reject((x) => {
        return x < 1 || x > this.totalPages;
      }).collect(function(x) {
        var old_last;
        [old_last, last] = [last, x];
        if (old_last + 1 === x) {
          return x;
        } else {
          return 'gap';
        }
      }).value();
    },
    hasNextPage: function() {
      return this.currentPage < this.totalPages;
    },
    hasPrevPage: function() {
      return 1 < this.currentPage;
    }
  },
  methods: {
    requestUrl: function(params = {}) {
      return Skylark.Helpers.UrlHelper.generateUrlWithParams(this.resourceUrl, _.extend({
        page: this.currentPage,
        per_page: this.currentPerPage
      }, params, this.additionalParams));
    },
    refresh: function() {
      return this.go(this.currentPage);
    },
    goNext: function() {
      return this.go(this.currentPage + 1);
    },
    goPrevious: function() {
      return this.go(this.currentPage - 1);
    },
    go: function(page = this.currentPage) {
      this.doRequest({
        page: page
      });
      return this.$emit('afterGo');
    },
    doRequest: function(params) {
      var ref;
      if ((ref = this._lastRequest) != null) {
        ref.abort();
      }
      this.beforeRequestFunc();
      return this._lastRequest = Skylark.Libs.Ajax.get(this.requestUrl(params), {
        success: (data, xhr) => {
          this.totalPages = parseInt(xhr.getResponseHeader('X-SLP-Total-Pages')) || 0;
          this.currentPage = parseInt(xhr.getResponseHeader('X-SLP-Current-Page')) || 1;
          this.totalCount = parseInt(xhr.getResponseHeader('X-SLP-Total-Count')) || 0;
          return this.$emit('dataReceived', data, {
            currentPage: this.currentPage,
            currentPerPage: this.currentPerPage,
            totalPages: this.totalPages,
            totalCount: this.totalCount
          });
        },
        error: (req, status) => {
          return this.$emit('error', req, status);
        },
        complete: () => {
          this._lastRequest = null;
          return this.afterRequestFunc();
        }
      });
    },
    changePerPageFunc: function(option) {
      this.currentPerPage = option;
      return this.go(1);
    },
    changePageFunc: function() {
      this.go(this.$refs.pageInputRef.value);
      return this.closePopoverFunc();
    },
    closePopoverFunc: function() {
      return this.$refs.pagePopoverRef.close();
    },
    resetCurrentPageInput: function() {
      var ref;
      return (ref = this.$refs.pageInputRef) != null ? ref.value = this.currentPage : void 0;
    },
    indexItemClassObj: function(page) {
      return {
        active: page === this.currentPage,
        disabled: !this.isDisplayPage(page)
      };
    },
    isDisplayPage: function(page) {
      return page !== 'gap';
    }
  }
});
